
import './App.css';
import TicTacToe  from './component/TicTacToe/TicTacToe';
//import TodoG from "./component/todoG/app"


function App() {
  return (
    <div >
      <TicTacToe />
      
    </div>
  );
}

export default App;
